import { render } from "./OrderInProgressPreviewComponent.vue?vue&type=template&id=370f97e8&scoped=true"
import script from "./OrderInProgressPreviewComponent.vue?vue&type=script&lang=js"
export * from "./OrderInProgressPreviewComponent.vue?vue&type=script&lang=js"

import "./OrderInProgressPreviewComponent.vue?vue&type=style&index=0&id=370f97e8&scoped=true&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370f97e8"]])

export default __exports__